module.exports = __webpack_public_path__ + "media/images/athletes/1711-3e3c1f76b17eb7661fb004e3342bb89e.png";